import { PrivacyPolicy } from '~/components/pages/pages-async.js';
import { useDispatch } from 'react-redux';
import { informationPagesClasses } from './constants.js';
import { HeadWrapper, MainTitle, SubTitle } from '~/components/misc/section-head.js';
import Icon, { ICON_LOCK_CLOSED_LINE } from '~/components/icon/index.js';
import useTranslations from '~/components/translation/use-translations.ts';
import { acceptPrivacyPolicy } from '~/components/authentication/ducks/index.js';

const textKeys = ['SIDE_MENU_PRIVACY_POLICY', 'MOBILE_PRIVACY_POLICY_SUPPORT_TITLE'];

// FIXME : we need to remove this prop spreading
const PrivacyPolicyConfigured = props => {
	const { translations: tr, isLoadingTranslations } = useTranslations(textKeys);
	const dispatch = useDispatch();

	const acceptPrivacyCB = () => {
		dispatch(acceptPrivacyPolicy());
	};
	return !isLoadingTranslations ? (
		<PrivacyPolicy
			wrapperClasses={informationPagesClasses}
			acceptPrivacyCB={acceptPrivacyCB}
			hideBackButton={props.hideBackButton}
			showAcceptPP={props.showAcceptPP} // not showing the button on main privacy policy page
			HeaderWrapper={
				<HeadWrapper>
					<Icon type={ICON_LOCK_CLOSED_LINE} />
					<MainTitle dataAt="section-main-title-general-global-overlay">
						{tr.SIDE_MENU_PRIVACY_POLICY}
					</MainTitle>
					<SubTitle dataAt="section-sub-title-header-general-global-overlay">
						{tr.MOBILE_PRIVACY_POLICY_SUPPORT_TITLE}
					</SubTitle>
				</HeadWrapper>
			}
			{...props}
		/>
	) : null;
};

export default PrivacyPolicyConfigured;
